<template>
  <Modal v-model="showWin" title="转给上级医生" width="500" :mask-closable="false">
    <div class="transfer-doctor">
      <div class="confirm-title">确认转给上级医生？</div>
      <div class="confirm-content">
        转交后，当前医术咨询将由上级医师回复。<strong>你已填写的治疗方案将被自动清空且无法恢复，请确认是否继续？</strong>
      </div>
    </div>
    <template #footer>
      <div class="footer-box">
        <Button @click="cancel">取消</Button>
        <Button type="primary" @click="confirm">确认转交</Button>
      </div>
    </template>
  </Modal>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showWin: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    cancel() {
      this.showWin = false;
      this.$emit("cancel");
    },
    confirm() {
      this.showWin = false;
      this.$emit("confirm");
    },
  },
};
</script>

<style lang="scss">
.transfer-doctor {
  .confirm-title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
  }
  .confirm-content {
    font-size: 14px;
    color: #666;
    line-height: 1.8;
  }
  .footer-box {
    display: flex;
    justify-content: flex-end;
    gap: 15px;
    padding-top: 20px;
    .ivu-btn {
      width: 120px;
      height: 36px;
      border-radius: 4px;
      &.ivu-btn-primary {
        background-color: #d9363e;
        border-color: #d9363e;
        &:hover {
          background-color: #c92c36;
          border-color: #c92c36;
        }
      }
    }
  }
}
</style>
